// Mirrors the backend InventoryNoteType DTO. Values must match exactly as the
// backend persists them.
export const INVENTORY_NOTE_TYPE_OPTIONS = [
  { label: "Waste", value: "Waste" },
  { label: "Damaged medications", value: "Damaged medications" },
  { label: "Expired inventory", value: "Expired inventory" },
  { label: "Unusable stock", value: "Unusable stock" },
];

export const ADD_INVENTORY_NOTES_DATA = {
  NOTES: "notes",
  NOTE_TYPE: "type",
  QUANTITY: "quantity",
  COMMENT: "comment",
};
